<template>
  <component
    :is="info.tag"
    :class="{
      'body-2 list-none flex flex-col items-start gap-16': info.tag === 'ul',
    }"
  >
    <component
      :is="info.subTag"
      v-for="text in info.text"
      :key="text"
      class="flex gap-12 whitespace-pre-line"
      :class="{ 'text-center': centered }"
    >
      <IconCheckSmall
        v-if="info.text && info.text.length > 1"
        class="shrink-0"
      />
      {{ text }}
    </component>
  </component>
</template>

<script setup lang="ts">
import { IconCheckSmall } from '@ds/icons/IconCheckSmall'

import type { Info } from '~/scopes/buyback/composables/useFunnelQuestions'

withDefaults(
  defineProps<{
    info: Info
    centered?: boolean
  }>(),
  {
    centered: false,
  },
)
</script>
